export const textValidatePlaceholder =
  'Mật khẩu của bạn phải có 6-12 ký tự bao gồm chữ và số!'

export const textValidateSpecialCharacters =
  'Mật khẩu của bạn phải có 6-12 ký tự bao gồm chữ và số hoặc ký tự đặc biệt'

export const textValidatePasswordAgain = 'Mật khẩu và mật khẩu nhập lại không trùng khớp'
